import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsInlineSkateNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5 0v.292a4.5 4.5 0 002.487 4.025l.194.097c.049-.036.098-.07.148-.104l3.736-2.49a5.5 5.5 0 014.727-.663l7.884 2.523A5.5 5.5 0 0128 8.92V9h2v3h-1.962a8.5 8.5 0 002.545 5.295l1.356-1.356 2.122 2.122-1.148 1.147.513.41a7.08 7.08 0 002.802 1.364l1.118.263A8.63 8.63 0 0144 29.647c0 1.363-.627 2.58-1.608 3.378l.54.879c.545.884.697 1.852.544 2.751A5 5 0 1136.1 40h-2.2a5 5 0 11-9.8 0h-2.2a5 5 0 11-9.8 0H9.9a5 5 0 11-8.31-2.657 3.964 3.964 0 01-.061-2.492l1.998-6.66a10.945 10.945 0 01-.612-6.777L6.222 7.037 6.146 7A7.5 7.5 0 012 .292V0zm10.377 4.015a2.5 2.5 0 00-2.148.3l-3.736 2.49a.5.5 0 00-.21.305L7.31 15.689l4.49 4.49a2.5 2.5 0 003.767-.269L19.25 15h6.398a11.49 11.49 0 01-.62-3H14V9h11v-.081a2.5 2.5 0 00-1.738-2.381zM27.231 18H20.75l-2.783 3.71a5.5 5.5 0 01-8.289.59l-3.161-3.162-.678 2.948a7.945 7.945 0 00.957 5.913H14c3.34 0 5.086.866 6.67 1.658l.023.011c1.406.703 2.66 1.33 5.307 1.33h13.648c.746 0 1.352-.605 1.352-1.352a5.63 5.63 0 00-4.341-5.48l-1.119-.264a10.082 10.082 0 01-3.988-1.941l-.773-.618-5.718 5.718-2.122-2.122 5.523-5.522c-.45-.44-.862-.915-1.23-1.417zM4.402 35.713A1 1 0 005.36 37h34.166a1 1 0 00.852-1.524l-.91-1.477H26c-3.34 0-5.086-.866-6.67-1.659l-.023-.01c-1.406-.704-2.661-1.331-5.307-1.331H6c-.061 0-.121-.004-.18-.01z"
        fill=""
      />
    </svg>
  )
);
SvgSportsInlineSkateNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsInlineSkateNormalLarge;
